import Tabs from './Tabs'
import TabList from './TabList'
import TabPane from './TabPane'

export {
  Tabs,
  TabList,
  TabPane
}



// WEBPACK FOOTER //
// ./~/vue-bulma-tabs/src/index.js